import { Row, Col } from "antd";
import { withTranslation } from "react-i18next";
import { Slide } from "react-awesome-reveal";
import {
    JoinUsBlockSection,
    ContentWrapper,
    CoreTitle,
    MinPara,
    StyledImage,
    SemicircleRectangle,
    TopHalfSemicircleRectangle,
    ActionButtonsWrapper,
    ActionButtonEmail,
    ActionButtonCall
} from "./styles";
import { ContentBlockProps } from "./types";


const JoinUsBlock = ({
    text1,
    text2,
    id,
    direction
}: ContentBlockProps) => {
    return (
        <JoinUsBlockSection id={id}>
            <SemicircleRectangle />
            <Slide direction="up" triggerOnce>
                <Row justify="center" align="middle">
                    <ContentWrapper>
                        <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'center' }}>
                            <StyledImage src="/img/Premier One Plus IDS Cross Logo.png" alt="Premier One Plus IDS Georgia" />
                            <CoreTitle>{text1}</CoreTitle>
                            <MinPara>{text2.split("PremierOne Plus IDS").map((part, index, arr) =>
                                index < arr.length - 1 ? (
                                    <>
                                        {part}
                                        <strong style={{ color: '#2A3273' }}>PremierOne Plus IDS</strong>
                                    </>
                                ) : (
                                    part
                                )
                            )}</MinPara>
                            <ActionButtonsWrapper>
                                <ActionButtonEmail href="mailto:pr@popmso.com?subject=Join%20Us%20Inquiry&body=Hello,%20I%20would%20like%20to%20know%20more.">Email</ActionButtonEmail>
                                <ActionButtonCall href="tel:+17609270927">Call</ActionButtonCall>
                            </ActionButtonsWrapper>
                        </Col>
                    </ContentWrapper>
                </Row>
            </Slide>
            <TopHalfSemicircleRectangle />
        </JoinUsBlockSection>
    );
};


export default withTranslation()(JoinUsBlock);
